<template>
  <div class="max-score max-panel" :data-intent="intent">
    <div
      class="max-score__ring"
      role="meter"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-valuenow="Math.round(node.value)"
      :aria-label="node.label"
      :style="{ '--max-score': shown }"
    >
      <span class="max-score__value">{{ Math.round(shown) }}</span>
    </div>
    <div>
      <p class="max-score__label">{{ node.label }}</p>
      <p v-if="node.caption" class="max-score__caption">{{ node.caption }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { useMaxContext } from '../runtime/context.ts'

const props = defineProps<{ node: any }>()
const ctx = useMaxContext()

const target = computed(() => Math.max(0, Math.min(100, Number(props.node.value) || 0)))
const shown = ref(target.value)

const intent = computed(() => {
  if (props.node.intent) return props.node.intent
  if (target.value >= 80) return 'positive'
  if (target.value >= 50) return 'warning'
  return 'negative'
})

function animate () {
  if (ctx.reducedMotion.value || typeof requestAnimationFrame === 'undefined') {
    shown.value = target.value
    return
  }
  const to = target.value
  const start = performance.now()
  shown.value = 0
  const step = (now: number) => {
    const t = Math.min(1, (now - start) / 1100)
    shown.value = to * (1 - Math.pow(1 - t, 3))
    if (t < 1) requestAnimationFrame(step)
  }
  requestAnimationFrame(step)
}

onMounted(animate)
watch(target, animate)
</script>
